const initState = {
  cookies: '',
  selectedPhase: 'phase-1',
  envValues: {
    reactAppUrl: process.env.REACT_APP_URL_PHASE_1
  },
  viewMode: 'normal',
  activeView: 'grid',
  storedOptionValue: 1,
  isFilteredProposals: false
}

const proposalsReducer = (state = initState, action) => {
  switch (action.type) {
    case 'FETCH_PROPOSALS_LOADING':
      return { ...state, loading: true, search: false, advanced: false }
    case 'FETCH_PROPOSALS_SUCCESS':
      return {
        ...state,
        err: false,
        initData: action.payload,
        data: action.payload,
        loading: false,
        search: false,
        advanced: false
      }
    case 'FETCH_PROPOSALS_ERROR':
      return {
        ...state,
        err: action.payload,
        data: false,
        loading: false,
        search: false,
        advanced: false
      }
    case 'FILTER_PROPOSALS_SUCCESS':
      return {
        ...state,
        err: false,
        data: action.payload,
        loading: false,
        search: false,
        advanced: false
      }
    case 'SEARCH_PROPOSALS_SUCCESS':
      return {
        ...state,
        search: true,
        advanced: false,
        searchProposals: action.payload.proposals,
        searchElements: action.payload.elements,
        loading: false
      }
    case 'ADVANCED_SEARCH_SUCCESS':
      return {
        ...state,
        advanced: true,
        search: false,
        advancedElements: action.payload,
        loading: false
      }
    case 'SORT_ALL_PROPOSALS_SUCCESS':
      return {
        ...state,
        err: false,
        data: action.payload,
        loading: false,
        search: false,
        advanced: false
      }
    case 'SORT_SEARCH_PROPOSALS_SUCCESS':
      return { ...state, searchProposals: action.payload }
    case 'UPDATE_PROPOSALS_COOKIES': {
      return { ...state, cookies: action.payload }
    }
    case 'SET_SELECTED_PHASE':
      return { ...state, selectedPhase: action.phaseId }
    case 'SET_BASE_URL':
      return {
        ...state,
        envValues: {
          reactAppUrl: action.baseUrl
        }
      }
    case 'SET_VIEW_MODE':
      return {
        ...state,
        viewMode: action.viewMode
      }
    case 'SET_ACTIVE_VIEW':
      return {
        ...state,
        activeView: action.activeView
      }
    case 'SET_STORED_OPTION_VALUE':
      return {
        ...state,
        storedOptionValue: action.value
      }
    case 'SET_IS_FILTERED_PROPOSALS':
      return {
        ...state,
        isFilteredProposals: action.value
      }
    default:
      return state
  }
}

export default proposalsReducer
